import BarChartBlock from './BarChartBlock';

export default BarChartBlock;
